/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressVerificationRequestDTO } from '../models/AddressVerificationRequestDTO';
import type { ApiResponseDTOAddressVerificationDelayDTO } from '../models/ApiResponseDTOAddressVerificationDelayDTO';
import type { ApiResponseDTOAddressVerificationResponseDTO } from '../models/ApiResponseDTOAddressVerificationResponseDTO';
import type { ApiResponseDTOBusinessAddressDTO } from '../models/ApiResponseDTOBusinessAddressDTO';
import type { ApiResponseDTOBusinessDetailsDTO } from '../models/ApiResponseDTOBusinessDetailsDTO';
import type { ApiResponseDTOBusinessDetailsResponseDTO } from '../models/ApiResponseDTOBusinessDetailsResponseDTO';
import type { ApiResponseDTOBusinessSectorsResponseDTO } from '../models/ApiResponseDTOBusinessSectorsResponseDTO';
import type { ApiResponseDTOBusinessSectorUpdateResponseDTO } from '../models/ApiResponseDTOBusinessSectorUpdateResponseDTO';
import type { ApiResponseDTOBusinessSubCategorySearchResponseDTO } from '../models/ApiResponseDTOBusinessSubCategorySearchResponseDTO';
import type { ApiResponseDTODirectorDetailsStepStatusDTO } from '../models/ApiResponseDTODirectorDetailsStepStatusDTO';
import type { ApiResponseDTODirectorsDetailsNigeriaDTO } from '../models/ApiResponseDTODirectorsDetailsNigeriaDTO';
import type { ApiResponseDTOListBusinessTypeDTO } from '../models/ApiResponseDTOListBusinessTypeDTO';
import type { ApiResponseDTOString } from '../models/ApiResponseDTOString';
import type { ApiResponseDTOVerifyCardNumberResponseDTO } from '../models/ApiResponseDTOVerifyCardNumberResponseDTO';
import type { ApiResponseDTOVoid } from '../models/ApiResponseDTOVoid';
import type { BusinessAddressDTO } from '../models/BusinessAddressDTO';
import type { BusinessDetailsDTO } from '../models/BusinessDetailsDTO';
import type { BusinessDetailsGhanaDTO } from '../models/BusinessDetailsGhanaDTO';
import type { BusinessDetailsNigeriaDTO } from '../models/BusinessDetailsNigeriaDTO';
import type { BusinessSectorUpdateRequestDTO } from '../models/BusinessSectorUpdateRequestDTO';
import type { DirectorsDetailsNigeriaDTO } from '../models/DirectorsDetailsNigeriaDTO';
import type { DirectorsRequestGhanaDTO } from '../models/DirectorsRequestGhanaDTO';
import type { VerifyCardNumberDTO } from '../models/VerifyCardNumberDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BusinessApiService {

    /**
     * Validate Digital Address
     * This service is responsible to validate if the business digital address is a valid address.
     * @param requestBody
     * @returns ApiResponseDTOAddressVerificationResponseDTO OK
     * @throws ApiError
     */
    public static addressVerificationGhana(
        requestBody: AddressVerificationRequestDTO,
    ): CancelablePromise<ApiResponseDTOAddressVerificationResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business/address-verification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Cancel Delayed Address Verification
     * Cancels the merchant's OkHi address verification once it has gone over 48 hours without an outcome. The upgrade's business address step reopens, as after a rejection, so the merchant can submit their address again; OkHi's later results for it are ignored.
     * @returns ApiResponseDTOString OK
     * @throws ApiError
     */
    public static cancelDelayedAddressVerification(): CancelablePromise<ApiResponseDTOString> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business/address-verification/cancel',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Address Verification Delay
     * Whether the merchant's OkHi address verification was submitted over 48 hours ago and is still neither approved nor rejected. Such a verification may be cancelled so the address can be submitted again.
     * @returns ApiResponseDTOAddressVerificationDelayDTO OK
     * @throws ApiError
     */
    public static getAddressVerificationDelay(): CancelablePromise<ApiResponseDTOAddressVerificationDelayDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/address-verification/delay',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Business Digital Address Status
     * Get status for address verification
     * @returns ApiResponseDTOAddressVerificationResponseDTO OK
     * @throws ApiError
     */
    public static getAddressVerificationStatusGh(): CancelablePromise<ApiResponseDTOAddressVerificationResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/address-verification/status',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get Business Address
     * Retrieve business address information.
     * @returns ApiResponseDTOBusinessAddressDTO OK
     * @throws ApiError
     */
    public static getBusinessAddress(): CancelablePromise<ApiResponseDTOBusinessAddressDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/business-addresses',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Submit Business Address
     * Submit the business address information
     * @param requestBody
     * @returns ApiResponseDTOBusinessAddressDTO OK
     * @throws ApiError
     */
    public static postBusinessAddress(
        requestBody: BusinessAddressDTO,
    ): CancelablePromise<ApiResponseDTOBusinessAddressDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business/business-addresses',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get business detail
     * Get the details of business page
     * @returns ApiResponseDTOBusinessDetailsDTO OK
     * @throws ApiError
     */
    public static getBusinessDetails(): CancelablePromise<ApiResponseDTOBusinessDetailsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/business-details',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Create / Update business detail for NG.
     * Create / Update the details of business page for NG.
     * @param requestBody
     * @returns ApiResponseDTOBusinessDetailsResponseDTO OK
     * @throws ApiError
     */
    public static saveBusinessDetails(
        requestBody: BusinessDetailsNigeriaDTO,
    ): CancelablePromise<ApiResponseDTOBusinessDetailsResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business/business-details',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Business details document page
     * Request create and post business details documents
     * @param requestBody
     * @returns ApiResponseDTOBusinessDetailsResponseDTO OK
     * @throws ApiError
     */
    public static upgradeBusinessDetailsDocuments(
        requestBody: BusinessDetailsGhanaDTO,
    ): CancelablePromise<ApiResponseDTOBusinessDetailsResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business/business-details-documents',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get business detail verification status for NG.
     * Get the details of business verification status for NG.
     * @returns ApiResponseDTOBusinessDetailsResponseDTO OK
     * @throws ApiError
     */
    public static getBusinessDetailsVerifcationStatus(): CancelablePromise<ApiResponseDTOBusinessDetailsResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/business-details-verification',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get approved business sector
     * Get the approved business sector of a merchant
     * @returns ApiResponseDTOString OK
     * @throws ApiError
     */
    public static getApprovedBusinessSectorOfMerchant(): CancelablePromise<ApiResponseDTOString> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/business-sector',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Update business sector
     * Update business sector information for the authenticated user
     * @param requestBody
     * @returns ApiResponseDTOBusinessSectorUpdateResponseDTO Business sector updated successfully
     * @throws ApiError
     */
    public static updateBusinessSector(
        requestBody: BusinessSectorUpdateRequestDTO,
    ): CancelablePromise<ApiResponseDTOBusinessSectorUpdateResponseDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/business/business-sector',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request - Invalid input parameters`,
                403: `Forbidden`,
                404: `Business details not found for user`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get business sectors
     * Get the business sectors
     * @param currentPage
     * @param pageSize
     * @returns ApiResponseDTOBusinessSectorsResponseDTO OK
     * @throws ApiError
     */
    public static getBusinessSectors(
        currentPage: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<ApiResponseDTOBusinessSectorsResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/business-sectors',
            query: {
                'currentPage': currentPage,
                'pageSize': pageSize,
            },
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Search Business Sectors by Name
     * Search for business sectors by sector name
     * @param sectorName
     * @returns ApiResponseDTOBusinessSectorsResponseDTO OK
     * @throws ApiError
     */
    public static searchBusinessSectorsByName(
        sectorName?: string,
    ): CancelablePromise<ApiResponseDTOBusinessSectorsResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/business-sectors/search',
            query: {
                'sectorName': sectorName,
            },
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Search business sub-categories
     * Suggests the business sub-categories that fit a keyword, most relevant first, each with its parent sector so both can be filled in. Tolerates typos, partial words, plurals and configured synonyms. A sector without sub-categories is suggested on its own name, without a sub-category. An empty list means nothing matched.
     * @param query
     * @param limit
     * @returns ApiResponseDTOBusinessSubCategorySearchResponseDTO OK
     * @throws ApiError
     */
    public static searchBusinessSubCategories(
        query?: string,
        limit?: number,
    ): CancelablePromise<ApiResponseDTOBusinessSubCategorySearchResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/business-sectors/sub-categories/search',
            query: {
                'query': query,
                'limit': limit,
            },
            errors: {
                400: `Fewer than 2 letters or digits to search for`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get business types
     * Get the business types
     * @returns ApiResponseDTOListBusinessTypeDTO OK
     * @throws ApiError
     */
    public static getBusinessTypes(): CancelablePromise<ApiResponseDTOListBusinessTypeDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/business-types',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Director Detail Document
     * API used to send Director Detail Document
     * @param requestBody
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static postDirectorDetailDocument(
        requestBody: DirectorsRequestGhanaDTO,
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business/directors-detail-document',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Save a list of directors
     * Save the list of user directors given the bvn
     * @param requestBody
     * @returns ApiResponseDTODirectorsDetailsNigeriaDTO OK
     * @throws ApiError
     */
    public static createDirectors(
        requestBody: DirectorsDetailsNigeriaDTO,
    ): CancelablePromise<ApiResponseDTODirectorsDetailsNigeriaDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business/directors-details',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get directors details verification status
     * Returns the verification status for the process step.
     * @returns ApiResponseDTODirectorDetailsStepStatusDTO OK
     * @throws ApiError
     */
    public static getDirectorsDetailsVerificationStatus(): CancelablePromise<ApiResponseDTODirectorDetailsStepStatusDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/directors-details/status',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Create/Update the business details page
     * Create/Update the details of business
     * @param requestBody
     * @returns ApiResponseDTOBusinessDetailsDTO OK
     * @throws ApiError
     */
    public static postBusinessDetails(
        requestBody: BusinessDetailsDTO,
    ): CancelablePromise<ApiResponseDTOBusinessDetailsDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business/upgrade/business-details',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Verify Card Number
     * API used to check the card number
     * @param requestBody
     * @returns ApiResponseDTOVerifyCardNumberResponseDTO OK
     * @throws ApiError
     */
    public static verifyCardNumber(
        requestBody: VerifyCardNumberDTO,
    ): CancelablePromise<ApiResponseDTOVerifyCardNumberResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business/verify-card-number',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

}
